var render = function () {
  var _vm$currentEquation, _vm$currentEquation2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": ("mathMaster " + (_vm.keyboardEnabled ? '' : 'full-height'))
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    attrs: {
      "slot": "content",
      "id": "mathMasterContent"
    },
    slot: "content"
  }, [_c('div', [_c('div', {
    attrs: {
      "id": "squares"
    }
  }, _vm._l((_vm$currentEquation = _vm.currentEquation) === null || _vm$currentEquation === void 0 ? void 0 : _vm$currentEquation.steps, function (step, index) {
    return !isNaN(step.answer) ? _c('square', {
      key: ("number" + index),
      class: [{
        answer: index === 4
      }],
      attrs: {
        "track-by": "$index",
        "number": step.answer
      }
    }) : _vm._e();
  }), 1), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('label', {
    staticStyle: {
      "opacity": "0",
      "position": "absolute"
    },
    attrs: {
      "aria-live": "polite"
    }
  }, [_vm._v(_vm._s(_vm.squaresDescription))])]), _c('div', {
    attrs: {
      "id": "expression"
    }
  }, _vm._l((_vm$currentEquation2 = _vm.currentEquation) === null || _vm$currentEquation2 === void 0 ? void 0 : _vm$currentEquation2.steps, function (step, index) {
    return _c('blinking-cursor-text', {
      key: ("step" + index),
      class: ['blink-text', {
        answer: index === 4
      }, {
        'number-step': _vm.checkIfNumber(step.answer)
      }],
      attrs: {
        "text": step.answer,
        "text-step": index
      }
    });
  }), 1)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.chooseAnswer,
      expression: "chooseAnswer"
    }],
    attrs: {
      "id": "results",
      "transition": "fade"
    }
  }, _vm._l(_vm.currentRound.answers, function (answer, index) {
    return _c('div', {
      key: ("result" + index),
      staticClass: "result focusable",
      attrs: {
        "track-by": "$index",
        "id": ("res" + index),
        "tabindex": "0"
      },
      on: {
        "click": function ($event) {
          return _vm.isCorrectAnswer(answer);
        },
        "keyup": function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.isCorrectAnswer(answer);
        }
      }
    }, [_c('square', {
      attrs: {
        "number": answer.answer
      }
    }), _c('p', {
      domProps: {
        "textContent": _vm._s(answer.answer)
      }
    })], 1);
  }), 0)])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }